var $events = {
  // ======================================================================
  // VARS
  // ======================================================================

  touching: false,
  timeout: null,

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    // TOUCH DETECTION
    $(window).on('touchstart', function() {
      clearTimeout($events.timeout);
      $events.touching = true;
    });
    $(window).on('touchend', function() {
      clearTimeout($events.timeout);
      $events.timeout = setTimeout(function() {
        $events.touching = false;
      }, 300);
    });

    // HIJAX
    $('body').on('click', 'a', function() {
      if ($pages.historyUse) {
        var target = $(this).attr('target');
        if (target === '_blank') {
          return;
        }
        var page = $(this).attr('href');
        if ($hijax.isSiteLink(page)) {
          // if ($windowsize.isDesktop) {
          var direction = $(this).attr('data-direction');
          $pages.show(page, direction);
          return false;
          // }
        }
      }
    });

    // SCROLL PROMPT
    $('body').on('click touchstart', '#js-scroll-prompt', function() {
      if ($scroll.enabled) {
        console.log('SCROLL');
        $(this).remove();
        $scroll.scrollToNav();
      }
    });
  }
};
